// extracted by mini-css-extract-plugin
export default {"header":"aYmXC16HhgXOHWsCOIEX","text":"IxKP4J338lcMVggXaDyp","buttons":"WlY0Hc8HRwtjdBSZRpYT","placeHolderShimmer":"nHyhjnXjxgsIwDrrvlOG"};